/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import {ActionRequestSymptomService} from "./ActionRequestSymptomService";

class ActionRequestSymptomServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new ActionRequestSymptomService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { ActionRequestSymptomServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/service/ActionRequestSymptomServiceProvider.js